import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './Notif.scss'

const iconMap = {
  danger: 'exclamation-circle',
  warn: 'exclamation-triangle',
  info: 'info-circle',
  success: 'check-circle',
}

type NotifProps = {
  body?: string
  level?: 'success' | 'info' | 'warn' | 'danger'
}

class Notif extends React.PureComponent<NotifProps> {
  renderIcon(level: any) {
    const icon = iconMap[level]
    if (!icon) return
    return (
      <div className="Notif-icon">
        <FontAwesomeIcon icon={icon} />
      </div>
    )
  }

  render() {
    const { level, body } = this.props
    const cname = 'Notif-root' + (level ? ` ${level}` : '')
    return (
      <div className={cname}>
        <div className="Notif-main">
          {level && this.renderIcon(level)}
          <div className="Notif-body">{body}</div>
        </div>
      </div>
    )
  }
}

export default Notif
